import { CircularSpinnerß } from '@otter-ai/den-components';
import type { PaymentPeriod } from '@otter-ai/recall-client';
import { useTranslations } from 'next-intl';
import { useState } from 'react';
import { OtterPlanType } from '@/shared/types/plan';
import { usePlanOptions } from '../../hooks/subscription/usePlanOptions';
import { CheckoutDialog } from './CheckoutDialog';

type CheckoutDialogWrapperProps = {
  done: () => void;
  planType: OtterPlanType;
  isEdu: boolean;
  cycle: PaymentPeriod;
  checkoutType: 'reactivate' | 'upgrade';
};

export function CheckoutDialogWrapper({
  done,
  planType,
  isEdu,
  cycle,
  checkoutType,
}: CheckoutDialogWrapperProps) {
  const t = useTranslations('settings:billing');

  const planOptions = usePlanOptions({
    planType,
    isEdu,
  });

  const [purchaseInProgress, setPurchaseInProgress] = useState(false);

  const planName =
    planType === OtterPlanType.PREMIUM
      ? t('plans.pro')
      : planType === OtterPlanType.TEAM
        ? t('plans.business')
        : '';

  const title =
    checkoutType === 'upgrade'
      ? t('actions.upgradeWithPlan', { plan: planName })
      : t('actions.reactivateWithPlan', { plan: planName });

  if (!planType) {
    return null;
  }

  const targetPlan =
    cycle === 'year' ? planOptions.annualPlan : planOptions.monthlyPlan;

  if (!targetPlan) {
    return null;
  }

  return (
    <CheckoutDialog
      done={done}
      title={
        <div className="text-2xl font-semibold mb-3 flex items-center justify-between">
          {title}
          {purchaseInProgress && (
            <CircularSpinnerß data-testid="checkout-confirmation-loader" />
          )}
        </div>
      }
      initialPlan={targetPlan}
      planOptions={planOptions}
      submitButtonText={title}
      checkoutType={checkoutType}
      testId="upgrade-dialog"
      purchaseInProgress={purchaseInProgress}
      setPurchaseInProgress={setPurchaseInProgress}
      isEdu={isEdu}
    />
  );
}
